import { Box, IconButton, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Download, Plus } from 'react-feather';
import { toast, Zoom } from 'react-toastify';
import { Card, CardHeader, Col, Container, Input, Row, Table } from 'reactstrap';
import { Donation_Export, Donation_MasterList } from '../../api/DonationMasterApi/DonationMasterApi';
import { ACCOUNT_TYPE, ERROR_CODE, EXPANCE, Style } from '../../constant';
import NoteContext from '../../context/NotesContext/NoteContext';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import DataNotFound from '../../DataNoteFound/DataNotFound';
import Breadcrumbs from '../../layout/breadcrumb';
import TableSkeleton from '../../loader/TableSkeleton';
import Actions from '../../utils/Actions';
import { currencyFormat, MuiTabelStyle } from '../../utils/helper';
import LogOut from '../../utils/logout';
import { useNavigate } from 'react-router';
import moment from 'moment';
import DonationPopup from '../dashboard/Donation/DonationPopup';
import useTempleTrustList from '../../utils/Hooks/useTempleTrustList';
import AdminDeshboardContext from '../../context/AdminDeshboardContext/AdminDeshboardContext';

const OrganizationItem = (props) => {
  const { setIsIncome, setModal } = useContext(AdminDeshboardContext);
  const {
    editHandle,
    showHandle,
    sorting,
    AddModel,
    setPage,
    setPageSize,
    pageSize,
    page,
    record,
    handleFilter,
    selected,
    setSelected
  } = props;
  const {
    formvalue,
    filter,

    startExpDate,
    setStartExpDate,
    endExpDate,
    setEndExpDate
  } = useContext(NoteContext);
  const { responseLoader } = useContext(OrganizationContext);
  const [dropDown, setDropDown] = useState([]);
  const [inputChangeFilter, setInputChangeFilter] = useState('');
  const history = useNavigate();
  const trustDropdown = useTempleTrustList();
  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 150,
      field: 'name',
      headerName: 'Name',
      renderCell: (params) => (params.row.personDetail.name ? params.row.personDetail.name : '--')
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'AccountDetail',
      headerName: 'Expance',
      renderCell: (params) => (params.row.AccountDetail.name ? params.row.AccountDetail.name : '--')
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'mobile',
      headerName: 'Phone',
      renderCell: (params) => (params.row.personDetail.mobile ? params.row.personDetail.mobile : '--')
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'amount',
      headerName: 'Amount',
      renderCell: (params) => (
        <div style={{ color: '#578b57', fontWeight: 'bold' }}>{params.row.amount ? params.row.amount : '--'}</div>
      )
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'dueAmount',
      headerName: 'Due Amount',
      renderCell: (params) => (
        <div
          style={{
            color: '#ff5f5f',
            fontWeight: 'bold'
          }}
        >
          {params.row.dueAmount ? params.row.dueAmount : '--'}
        </div>
      )
    },
    {
      flex: 0.15,
      minWidth: 300,
      field: 'note',
      headerName: 'Note',
      renderCell: (params) => (params.row.note ? params.row.note : '--')
    },
    {
      flex: 0.1,
      minWidth: 200,
      field: 'createdAt',
      headerName: 'Date',
      renderCell: (params) =>
        params.row.createdAt ? moment(params.row.createdAt).format('DD MMM YYYY, hh:mm A') : '--'
    },
    {
      flex: 0.08,
      minWidth: 150,
      field: 'actions',
      headerName: 'Actions',
      sortable: false,

      renderCell: (params) => (
        <>
          <Actions params={params} editHandle={editHandle} showHandle={showHandle} />
        </>
      )
    }
  ];

  const getData = async () => {
    try {
      let paramsObj = {
        // pageNumber: page,
        // recordsPerPage: 10,
        sortOrder: 'ASC',
        search: { type: ACCOUNT_TYPE.outward },
        showAll: true
      };
      if (inputChangeFilter.length) {
        paramsObj['search'] = {
          name: inputChangeFilter,
          type: ACCOUNT_TYPE.outward
        };
      }
      const { data } = await Donation_MasterList(paramsObj);
      if (data.status === 200) {
        setDropDown(data.payload.data);
      } else {
        setDropDown([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };
  let newArray = dropDown.map((elem) => {
    return { label: elem.name };
  });
  useEffect(() => {
    getData();
  }, [page, pageSize, inputChangeFilter]);
  const handleChange = (e) => {
    setSelected(e);
  };
  const handleInputChange = (e) => {
    setInputChangeFilter(e);
  };

  const handleDownloadExcel = async () => {
    try {
      let paramObj = {
        search: {
          type: ACCOUNT_TYPE.outward
        }
      };
      if (
        startExpDate !== 'Invalid date' &&
        startExpDate !== null &&
        startExpDate !== undefined &&
        startExpDate !== '' &&
        startExpDate
      ) {
        paramObj['search'] = { ...paramObj.search, startDate: startExpDate };
      }
      if (
        endExpDate !== 'Invalid date' &&
        endExpDate !== null &&
        endExpDate !== undefined &&
        endExpDate !== '' &&
        endExpDate
      ) {
        paramObj['search'] = { ...paramObj.search, endDate: endExpDate };
      }
      if (selected[0]) {
        paramObj['search'] = {
          ...paramObj.search,
          accountName: selected[0].label
        };
      }
      if (filter.length && typeof filter === 'string') {
        paramObj['search'] = {
          ...paramObj.search,
          type: ACCOUNT_TYPE.outward,
          name: filter
        };
      }
      if (filter >= 1 && typeof Number(filter) === 'number') {
        paramObj['search'] = {
          ...paramObj.search,
          type: ACCOUNT_TYPE.outward,
          mobile: +filter,
          name: ''
        };
      }
      const { data } = await Donation_Export(paramObj);
      // Convert response data to Blob
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // Create a link element
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Expense-${moment().format('DD-MMM-YY-hh-mm')}.xlsx`;

      // Trigger the download
      link.click();
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  return (
    <>
      <Fragment>
        <Breadcrumbs parent={EXPANCE.EXPANCE_PARENT} />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <h3>{EXPANCE.EXPANCE_PARENT}</h3>
                  <div
                    aria-label="add"
                    className="btn btn-primary"
                    onClick={() => {
                      setModal(true);
                      setIsIncome(true);
                      trustDropdown();
                    }}
                    style={Style}
                  >
                    <Plus />
                  </div>
                </CardHeader>

                {formvalue?.report && (
                  <div className="px-4 pt-3 pb-2">
                    <Row>
                      {Object.entries(formvalue?.report).map((tot, index) => (
                        <Col md="4" key={index} className="mb-0">
                          <div className="p-3 border rounded shadow-sm text-center bg-light">
                            <h6 className="text-muted mb-2">{tot[0]}</h6>
                            <h4
                              className={`mb-0 ${
                                tot[0].toLowerCase().includes('due') ? 'text-danger' : 'text-primary'
                              }`}
                            >
                              {currencyFormat(tot[1])}
                            </h4>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}

                <Table>
                  <thead>
                    <tr>
                      <th>
                        <div className="d-flex">
                          <Row className="w-100 ">
                            <Col md="2 mb-2">
                              <Input
                                className="form-control"
                                type="search"
                                placeholder="Expanse Search..."
                                value={filter}
                                onChange={(e) => handleFilter(e)}
                              />
                            </Col>
                            <Col md="2 mb-2">
                              <Typeahead
                                id="basic-example"
                                onInputChange={(e) => handleInputChange(e)}
                                onChange={(e) => handleChange(e)}
                                options={newArray}
                                placeholder="Expanse Type Search..."
                                selected={selected}
                                clearButton
                              />
                            </Col>
                            <Col md="2 mb-2">
                              <input
                                type="date"
                                className="form-control colorBlack"
                                value={startExpDate}
                                onChange={(e) => {
                                  setStartExpDate(moment(e.target.value).format('YYYY-MM-DD'));
                                }}
                              />
                            </Col>
                            <Col md="2 mb-2">
                              <input
                                type="date"
                                className="form-control colorBlack"
                                value={endExpDate}
                                onChange={(e) => {
                                  setEndExpDate(moment(e.target.value).format('YYYY-MM-DD'));
                                }}
                                min={startExpDate}
                              />
                            </Col>
                          </Row>
                          <div className="w-100 d-flex justify-content-end align-items-center  ">
                            <Tooltip title="Excel">
                              <IconButton
                                aria-label="edit"
                                style={{
                                  background: '#dcf1dc',
                                  marginRight: '5px'
                                }}
                                onClick={() => handleDownloadExcel()}
                              >
                                <Download
                                  style={{
                                    color: 'green',
                                    width: '19px',
                                    height: '19px'
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </Table>
                <Box
                  sx={{
                    '& .even': {
                      backgroundColor: '#f1f1f1'
                    },
                    '& .odd': {
                      backgroundColor: 'white'
                    }
                  }}
                >
                  {responseLoader === true ? (
                    <TableSkeleton />
                  ) : formvalue?.data?.length ? (
                    <DataGrid
                      sx={MuiTabelStyle}
                      autoHeight
                      pagination
                      rows={formvalue?.data}
                      rowCount={record}
                      pageSize={pageSize}
                      getRowId={(row) => row.accountTransactionId}
                      columns={defaultColumns}
                      page={page - 1}
                      rowsPerPageOptions={[7, 10, 25, 50]}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                      paginationMode="server"
                      disableSelectionOnClick
                      checkboxSelection={false}
                      sortingMode="server"
                      onSortModelChange={sorting}
                      getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
                    />
                  ) : (
                    <DataNotFound />
                  )}
                </Box>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
      <DonationPopup getExpanse={getData} type={ACCOUNT_TYPE.outward} modalName="Expanse" />
    </>
  );
};

export default OrganizationItem;
